import React from "react";

const GoogleMaps: React.FC = () => {
  return (
    <div className="rounded-xl">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d5995.568205620437!2d69.250945!3d41.291803!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDHCsDE3JzMwLjUiTiA2OcKwMTUnMDMuNCJF!5e0!3m2!1suz!2s!4v1722438615039!5m2!1suz!2s"
        width="100%"
        height="400"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="rounded-lg no-border"
      ></iframe>
    </div>
  );
};

export default GoogleMaps;
